module.exports = __webpack_public_path__ + "img/remove.aa7adcfc.svg";